var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/core/components/Forms/FieldGroup.js",
    _this = this;

import React from 'react';
import styled, { css } from 'styled-components';
import FormFieldHint from './FormFieldHint';
import HintText from './HintText';
import { CheckboxWrapper } from '../../../components/Checkbox/CheckboxInput';
import { withTheme } from '../../ThemeProvider'; // TODO Sudhir: !CODE-DUPLICATION Use this component for Radio component.

var FieldGroup = function FieldGroup(_ref) {
  var children = _ref.children,
      error = _ref.error;
  return /*#__PURE__*/React.createElement("div", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(FieldGroupContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 7
    }
  }, children), error && /*#__PURE__*/React.createElement(FormFieldHint, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(HintText, {
    error: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 11
    }
  }, error)));
};

export default FieldGroup;
var FieldGroupContainer = withTheme(styled.div.withConfig({
  displayName: "FieldGroup__FieldGroupContainer",
  componentId: "sc-x71hl4-0"
})(function (_ref2) {
  var coreTheme = _ref2.coreTheme;
  return css(["", "{margin-bottom:", "px;&:last-of-type{margin-bottom:0;}}"], CheckboxWrapper, coreTheme.space_4);
}));